export const isTestingEnvironment = process.env['STORYBOOK'] == 'true'
